import React from 'react';
import { motion } from 'framer-motion';
import { Mic, FolderPlus, History } from 'lucide-react';
const steps = [{
  id: '01',
  title: 'Capture',
  description: 'Import transcripts, notes, or requirement docs for a client project.',
  icon: <Mic className="h-6 w-6 text-white" data-id="element-146" />
}, {
  id: '02',
  title: 'Create',
  description: "Automatically create requirements, tasks, documentation, and fill out data import templates in your client's ERP format.",
  icon: <FolderPlus className="h-6 w-6 text-white" data-id="element-147" />
}, {
  id: '03',
  title: 'Track',
  description: 'Assign tasks, track systems, store documentation, and maintain audit history per client.',
  icon: <History className="h-6 w-6 text-white" data-id="element-148" />
}];
export function HowItWorks() {
  return <section className="py-24 bg-slate-50 border-y border-slate-200" data-id="element-149">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-150">
        <div className="text-center mb-16" data-id="element-151">
          <h2 className="text-3xl font-bold text-slate-900" data-id="element-152">How it works</h2>
          <p className="mt-4 text-slate-600" data-id="element-153">
            From raw conversation to managed project in three steps.
          </p>
        </div>

        <div className="relative" data-id="element-154">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-8 left-[16%] right-[16%] h-0.5 bg-gradient-primary -z-10" data-id="element-155" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-156">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="flex flex-col items-center text-center bg-white md:bg-transparent p-6 md:p-0 rounded-xl border md:border-0 border-slate-200 shadow-sm md:shadow-none" data-id="element-157">
                <div className="relative mb-6" data-id="element-158">
                  <div className="h-16 w-16 bg-gradient-primary rounded-2xl flex items-center justify-center shadow-lg shadow-primary-blue/30 relative" data-id="element-159">
                    {step.icon}
                  </div>
                  <div className="absolute -top-3 -right-3 h-8 w-8 bg-slate-900 rounded-full flex items-center justify-center text-white text-xs font-bold border-2 border-white z-10" data-id="element-160">
                    {step.id}
                  </div>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-161">
                  {step.title}
                </h3>
                <p className="text-slate-600 max-w-xs mx-auto" data-id="element-162">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}